import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from "@angular/material-moment-adapter"

const MY_FORMATS = {
  parse: {
    dateInput: 'yyyy-MM-DD', // Database format is yyyy-MM-DD
  },
  display: {
    dateInput: 'DD/MM/yyyy',
    monthYearLabel: 'MMMM yyyy',
    dateA11yLabel: 'DD/MM/YYY',
    monthYearA11yLabel: 'MM yyyy',
  },
}

export const DATE_CONFIG = [
  { provide: MAT_DATE_LOCALE, useValue: "fr-FR" },
  { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE,MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
]
